import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('documentation-list/index', {params});
    },
    getdocumentation(params) {
        return Service().get('documentation-list/get-spare-part', {params});
    },
    show(id) {
        return Service().get('documentation-list/show/'+id);
    },
    create(params) {
        return Service().post('documentation-list/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('documentation-list/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('documentation-list/delete/'+id);
    },
}